<template>
    <div class="chart-container">
        <img :src="require(`@/assets/turbidity/${cupLvl}.png`)" :alt="turbidity" class="cup-icon" />
    </div>
</template>

<script>
export default {
    name: 'WaterChart',
    props: {
        chartId: {
            type: String,
            default: 'line-chart',
        },
        cssClasses: {
            type: String,
            default: '',
        },
        turbidity: {
            type: Number,
        },
    },
    data() {
        return {}
    },
    computed: {
        cupLvl() {
            let cupLvl = this.turbidity
            let cupList = [30, 10, 0]
            for (let i = 0; i < cupList.length; i++) {
                if (cupLvl >= cupList[i]) {
                    cupLvl = cupList[i]
                    break
                }
            }
            return cupLvl
        },
    },
}
</script>

<style lang="scss" scoped>
.chart-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .cup-icon {
        max-width: 100%;
        max-height: 100%;
        height: auto;
        width: auto;
        border-radius: 10px;
    }
}
</style>
